import * as React from 'react';
import {useEffect} from 'react';
import {useIntl} from 'react-intl';
import {Card, Row, Col} from 'antd';
import AppPageMetadata from 'src/domain/core/AppPageMetadata';
import ProductRejectionReasonsHeader from './product-rejection-reasons-header';
import ProductRejectionReasonsTable from './product-rejection-reasons-table';
import {useBreadcrumbContext} from 'src/domain/utility/AppContextProvider/BreadcrumbContextProvider';
import IntlMessages from 'src/domain/utility/IntlMessages';

interface ProductRejectionReasonsProps {}

const ProductRejectionReasons: React.FC<ProductRejectionReasonsProps> = () => {
  const {messages} = useIntl();
  const {setBreadcrumb}: any = useBreadcrumbContext();

  useEffect(() => {
    setBreadcrumb([
      {
        text: <IntlMessages id='Catalog.sideBarName' />,
        url: '/catalog/products',
      },
      {
        text: <IntlMessages id='catalog.productRejectionReasons' />,
        url: '/catalog/product-rejection-reasons',
      },
    ]);
  }, []);

  return (
    <AppPageMetadata
      title={messages['productRejectionReasons.title'].toString()}>
      <Card>
        <Row gutter={[0, 48]}>
          <Col span={24}>
            <ProductRejectionReasonsHeader />
          </Col>

          <Col span={24}>
            <ProductRejectionReasonsTable />
          </Col>
        </Row>
      </Card>
    </AppPageMetadata>
  );
};

export default ProductRejectionReasons;
